const errorMessage={
    'no_auth':'您暂无权限接单此任务',
    'already_token':'该任务已被接单.',
    'invalid_buyer':'买手不合法',
    'wrong_data':'数据错误',
    'unauthorized_operation':'无操作权限'
}

export {
    errorMessage
}


// WEBPACK FOOTER //
// ./src/services/error.js